<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto mt-2" *ngIf="this.claimId">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                    [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Exposure</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="pages_space">
        <section id="stage1" class="outline_exp" *ngIf="showStage1">
            <div class="row">
                <div class="col-12">
                    <div class="form-row align-items-center justify-content-center">
                        <div class="col-auto text-center">
                            <label class="me-3">Add a noise exposed activity</label>
                            <k-button [type]="KButtonType.KLAiMSButton" [label]="'Add Exposure'" [color]="'brand-main'"
                                (buttonClick)="addNewExposure()">
                            </k-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div>
            <p class="mb-2"><b>Exposure Summary</b></p>
            <section class="exposureGrid">
                <k-table-grid (clickOnActionEvent)="getTableData($event, editContent)"></k-table-grid>
            </section>
            <br>
            <section>
                <div class="col-12 text-center" *ngIf="this.sampleData.length > 0">
                    <k-button [type]="KButtonType.KLAiMSButton" [label]="'Complete NIHL Exposure'"
                        [color]="'brand-main'" (buttonClick)="completeNIHLExposure()">
                    </k-button>
                </div>
            </section>
        </div>
    </div>
</div>

<!-- Modal -->
<ng-template #editContent let-modal>
    <div class="modal-header">
        <h5 class="modal-title ">Edit Notional Exposure </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div>

            <div class="row">
                <label class="col-auto col-form-label">Employer Name :</label>
                <div class="col  col-form-label pl-0">
                    {{this.currentEmployerName}}
                </div>
            </div>

            <span>Select the noise level the claimant was exposed to </span>
            <b><k-label [tooltipText]="'mm exposed'" [helpText]="'mm exposed'" for="dropdown"
                    [required]="false">Notional Exposure (dB) LEP'd</k-label></b>
            <form name="outlineExposureForm" [formGroup]="outlineExposureForm">
                <k-dropdown formControlName="notionalExposure" name="notionalExposure"
                    [options]="notionalExposureList"></k-dropdown>
                <div *ngIf="isSubmitted && f.notionalExposure.errors" class="errors_block">Notional exposure is required
                </div>

            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
            Cancel</button>
        <button type="button" class="btn-brand-main klaim_btn text-center"
            (click)="updateNotionalExposure(outlineExposureForm)">
            Update</button>
    </div>
</ng-template>
<!-- Modal End -->

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>